import { Toast, ToastClose, ToastDescription, ToastTitle, ToastViewport } from '@/components/ui/toasts/toast';
import { ToasterToast, useToast } from '@/hooks/use-toast';
import { cn } from '@/utils/utils_client';
import * as ToastPrimitives from '@radix-ui/react-toast';
import { useState } from 'react';

export function PROVIDER__toast() {
  const { toasts } = useToast();
  const [is_hovered, set_is_hovered] = useState(false);

  function render_toast(toast: ToasterToast) {
    const { id, title, description, action, hide_button_close = false, className, ...props } = toast;

    return (
      <Toast key={id} {...props} className={cn(className)}>
        <div
          onMouseEnter={() => set_is_hovered(true)}
          onMouseLeave={() => set_is_hovered(false)}
          onPointerUp={e => e.stopPropagation()} //e.stopPropagation() need for prevent shadcn internal close toast logic
          className="flex flex-col gap-2 w-full h-full p-6 !pointer-events-auto"
        >
          {title && <ToastTitle>{title}</ToastTitle>}
          {description && <ToastDescription>{description}</ToastDescription>}
          {action && <div className="content !pointer-events-auto comment-wrapper_for_pointer_events_class">{action}</div>}
        </div>

        {!hide_button_close && <ToastClose is_hovered={is_hovered} />}
      </Toast>
    );
  }

  return (
    <ToastPrimitives.Provider>
      {toasts.map(render_toast)}
      <ToastViewport />
    </ToastPrimitives.Provider>
  );
}
